import Layout from "../../components/layout";
import CategoryCard from "./components/categoryCard";
import PageHeader from "../../components/pageHeader";
import CategorySection from "./components/categorySection";
import Cart, { MobileCart } from "./components/cart";
import useFetch, { IMAGES_BASE_URL } from "../../utils/useFetch";
import { createRef, useCallback, useEffect, useRef, useState } from "react";
import { IFood } from "../../components/foodCard/food.interface";
import FoodCard from "../../components/foodCard";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { useNavigate } from "react-router-dom";

interface ICategory {
  name: string;
  image: string;
  id: number;
}

const Home = () => {
  const { data: categories } = useFetch<ICategory[]>("cat");
  const { data: foods } = useFetch<IFood[]>("v2/all_meals");

  const authenticated = useSelector((store: RootState) => store.user.isLogin);
  const userInfo = useSelector((store: RootState) => store.user.userInfo);

  const navigate = useNavigate();

  const [search, setSearch] = useState("");
  const [searchedFoods, setSearchedFoods] = useState<IFood[]>([]);
  const [showUp, setShowUp] = useState(false);
  const [menuTilteDistanceToTop, setMenuTilteDistanceToTop] = useState(0);
  const [categoriesRefs, setCategoriesRefs] = useState<any[]>([]);
  const handleSearchChange = (e: any) => {
    const fieldValue = e.target.value;
    setSearch(fieldValue);
    findInFoods(fieldValue);
  };
  const findInFoods = (searchPhrase: string) => {
    const searchResults = foods?.filter((food) =>
      food.name.includes(searchPhrase)
    );
    if (searchResults?.length === 0) {
      console.log("NOT FOUND");
    } else {
      setSearchedFoods(searchResults!);
    }
  };

  const menuTitle = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const _menuTitleDistanceToTop =
      menuTitle.current?.getBoundingClientRect().top;
    setMenuTilteDistanceToTop(_menuTitleDistanceToTop!);

    window.addEventListener("scroll", () => {
      const winScroll =
        document.body.scrollTop || document.documentElement.scrollTop;
      if (winScroll - 64 > _menuTitleDistanceToTop!) {
        setShowUp(true);
      } else {
        setShowUp(false);
      }
    });
    return () => window.removeEventListener("scroll", () => {});
  }, []);

  const scrollUpToMenu = () => {
    window.scrollTo({
      top: menuTilteDistanceToTop,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    if (authenticated && userInfo.name === null) {
      navigate("/completesignup");
    }
  }, [authenticated, navigate, userInfo]);

  useEffect(() => {
    if (categories) {
      const refs = categories!.reduce((acc: any, value) => {
        acc[value.id] = createRef();
        return acc;
      }, {});
      setCategoriesRefs(refs);
    } else {
      setCategoriesRefs([]);
    }
  }, [categories]);

  const onMenuItemClick = useCallback(
    (catId: number) => {
      console.log(categoriesRefs[catId]);
      categoriesRefs[catId].current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    },
    [categoriesRefs]
  );

  return (
    <Layout>
      <PageHeader />
      <section className='container mx-auto flex '>
        <div className='flex-1 border lg:ml-8 bg-white'>
          <div
            className='p-2 font-bold border-b border-solid flex sticky top-0 bg-white'
            ref={menuTitle}
          >
            <div
              className='flex-1 text-lg'
              onClick={scrollUpToMenu}
            >
              <FontAwesomeIcon
                className={`${showUp ? "inline" : "hidden"} pl-1 text-rose-900`}
                icon={faArrowUp}
              />
              منوی سفارش
            </div>
            <div>
              <input
                type='text'
                className='border rounded p-1 pr-0'
                placeholder='جستجوی سریع ...'
                value={search}
                onChange={(e) => handleSearchChange(e)}
              />
            </div>
          </div>
          <div
            className={`grid grid-cols-4 md:grid-cols-6 lg:grid-cols-8 gap-2 py-2 border-b ${
              search.length > 2 ? "hidden" : "block"
            }`}
          >
            {categories &&
              categories.map((category: ICategory) => (
                <CategoryCard
                  key={category.id}
                  handleClick={() => onMenuItemClick(category.id)}
                  categoryTitle={category.name}
                  categoryIcon={IMAGES_BASE_URL + category.image}
                />
              ))}
          </div>

          <div>
            {categories &&
              foods &&
              search.length < 3 &&
              categories.map((category: ICategory) => {
                return (
                  <CategorySection
                    key={category.id}
                    refId={categoriesRefs[category.id]}
                    categoryId={category.id}
                    categoryTitle={category.name}
                    foods={foods?.filter(
                      (food: IFood) => food.category_id === category.id
                    )}
                  />
                );
              })}
          </div>

          <div>
            {categories && foods && search.length > 0 && (
              <>
                <div className=' mt-4 pb-4'>
                  <div className='font-bold text-xl mt-4 mr-2 text-gray-500'></div>
                  <div>
                    {searchedFoods.map((food: IFood) => (
                      <FoodCard data={food} />
                    ))}
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
        <div className='w-80 hidden lg:block'>
          <Cart isFromCheckoutPage={false} />
        </div>

        <MobileCart />
      </section>
    </Layout>
  );
};

export default Home;
